module.exports = __webpack_public_path__ + "img/img7.f3c4e4d8.svg";